// extracted by mini-css-extract-plugin
export default {"back":"CheckoutPage_back__OI3QQ","btn_prev_2":"CheckoutPage_btn_prev_2__twzSM"};